import  { createContext, useContext } from "react";

export type UserInfoType = {
  user_id: string;
  is_active: boolean;
  name: string;
  groups: string[];
  permissions: {
    resource_key: string;
    actions: string[];
  }[];
  buyer_code: string;
  user_image: string;
  pubsub_token: string;
  pubsub_url: string;
  is_lock: boolean;
};

export const UserInfoContext = createContext<UserInfoType | null>(null);

export const useUserInfo = () => useContext(UserInfoContext);